import { AuthPanel } from '@ccp/ui';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { safeReturnPath } from '../../app/shell/areas.js';
import { SignInForm } from '../../features/auth/components/sign-in-form.js';
import { currentOrRestoredStatus } from '../../session/session.js';

interface LoginSearch {
  /** Where to go once they are in, so a deep link survives the sign-in. */
  readonly redirect?: string;
}

export const Route = createFileRoute('/auth/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  async beforeLoad({ search }) {
    // Somebody who is already signed in has no business on the sign-in page; the cookie may well
    // still be good from another tab.
    if ((await currentOrRestoredStatus()) === 'authenticated') {
      throw redirect({ to: safeReturnPath(search.redirect) });
    }
  },
  component: Login,
});

function Login() {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  const { redirect: returnTo } = Route.useSearch();
  const [key, setKey] = useState(0);

  return (
    <AuthPanel title={t('signIn.title')} description={t('signIn.description')}>
      <SignInForm
        key={key}
        returnTo={safeReturnPath(returnTo)}
        onSignedIn={() => void navigate({ to: safeReturnPath(returnTo) })}
        onStartOver={() => setKey((current) => current + 1)}
      />
    </AuthPanel>
  );
}
